import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';
window.application.register("line-chart", 
	class extends Stimulus.Controller {
		static get targets() {
		  return [ "canvas","minDate","maxDate" ]
		}

		connect(){
			this.element[this.identifier] = this;
			this.dataset = [];

			var a = JSON.parse(this.data.get('dataset'));
			//only show data after 2016
			var b = a.map(data => {
				return {
					x: moment(data.date, 'YYYY-MM-DD').valueOf(),
					y: parseFloat(data.price)
				}
			});
			this.dataset = b;
			this.render();
		}

		render(){
			var minDate = this.dataset[0].x;
			var maxDate = this.dataset[this.dataset.length-1].x;
			try{
				minDate = this.minDateTarget.date.value.valueOf();
				maxDate = this.maxDateTarget.date.value.valueOf();
				if(minDate > maxDate){
					this.minDateTarget.date.value = this.maxDateTarget.value;
				}
				minDate = this.minDateTarget.date.value.valueOf();
				maxDate = this.maxDateTarget.date.value.valueOf();
			}catch(err){
				
			}
			var dataset = this.dataset.filter(data => data.x>=minDate && data.x <= maxDate)
			// console.log(dataset.length);
			if(this.chart){
				this.chart.data.labels = [dataset[0].x, dataset[dataset.length-1].x];
				this.chart.data.datasets[0].data = dataset;
				this.chart.update();
			}else{
				// console.log(dataset.length);
				this.chart = new Chart(this.canvasTarget.getContext('2d'), {
		    		type: 'line',
					data: {
						// labels: [dataset[0].x, dataset[dataset.length-1].x],
					    datasets: [{
					    	borderColor: '#E87722',
					    	pointBackgroundColor:'#E87722',
					    	pointRadius: 2,
					    	borderWidth: 1,
					        data: dataset
					    }]
					},
					options: {
						responsive: true,
						maintainAspectRatio: true,
						aspectRatio: this.data.get('aspect')?parseFloat(this.data.get('aspect')):2,
						plugins:{
							legend: {
								display: false,
							},
						},
						scales:{
							x:{
								type: 'time',
								// bounds: 'ticks',
								time: {
									tooltipFormat: 'dd MMMM yyyy',
									// stepSize: 100,
									// minUnit: 'day'
									// unit: 'day',
				                 	// displayFormats: {
				                        // month: 'MMM yy'
				                    // }
								},
								// ticks:{
								// 	// 'source':'labels'
								// 	// padding: 10,
								// },

							},
							y:{
								type: 'linear',
								grace: '3%'
							}
						},
					    parsing: false,
					    animation:false
					}
				});
			}
		}

		disconnect(){
			try{this.tearDown()}catch(err){};
		}

		tearDown(){
			// this.element.innerHTML = '';
		}
	}
)